module.exports = __webpack_public_path__ + "static/media/category14.063f8c05.jpg";